import type { FC } from 'react';
import { useRef } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationMediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
import { useDeviationMatureFilter } from '@wix/da-shared-react/pkg/utils/hooks/useDeviationMatureFilter';

import s from './ProfileHero.scss';

export interface Props {
  coverDeviation?: PapiDeviation;
  showProfileHeroAid?: boolean;
  className?: string;
  isGroup?: boolean;
}

export const ProfileHero: FC<Props> = ({ coverDeviation, className, isGroup = false }) => {
  const rootDivRef = useRef<HTMLDivElement>(null);
  const { showBlocked } = useDeviationMatureFilter(coverDeviation);

  let image;
  if (coverDeviation) {
    if (showBlocked) {
      image = DeviationMediaService.getSmallestThumb(coverDeviation);
    } else {
      image = DeviationMediaService.getDeviationFile(coverDeviation, 'fullview');
    }
  } else {
    // default cover image
    if (isGroup) {
      image = {
        src: 'https://st.deviantart.net/eclipse/empty-states/group-cover-image.png',
      };
    }
  }

  return (
    <div
      ref={rootDivRef}
      className={classnames(
        s['root'],
        !image && s['no-image'],
        className,
        showBlocked && s['mature-blur']
      )}
      style={{
        backgroundImage: image ? `url(${image.src})` : undefined,
      }}
    ></div>
  );
};
ProfileHero.displayName = 'ProfileHero';

export default ProfileHero;
